import React, { FC, useEffect, useState } from "react";
import classes from "./ProductItemContainer.module.scss";
import { Box } from "@mui/material";
import { userState } from "../../states/userState";
import { useRecoilState } from "recoil";
import { User } from "../types/user";
import {
  backGroundColorCode,
  foreColorCode,
  foreColorCodeOnMouseOver,
} from "../../commons/colors";
import SelectProductItemsModal from "./modal/SelectProductItemsModal";
import { productItems, productItemType } from "../../commons/productItems";

const createDisplayProdutItems = (
  ids: Number[],
  productItems: productItemType[]
) => {
  // console.log(
  //   "ids.length",
  //   ids.length,
  //   "productItems.length",
  //   productItems.length
  // );

  if (ids.length == productItems.length) return [{ id: 0, name: "全区分" }];
  return ids.map((id) => {
    const product: productItemType = productItems.find(
      (item) => item.id === id
    ) as productItemType;
    return { id: product.id, name: product.name };
  });
};

const ProductItemsContainer: FC = () => {
  const [user, setUser] = useRecoilState<User>(userState);
  const [isShowProductItemSelectModal, setIsShowProductItemSelectModal] =
    useState(false);
  const [displayText, setDisplayText] = useState<
    { id: number; name: string }[]
  >([]);
  useEffect(() => {
    setDisplayText((prev) => {
      const newDisplayText = createDisplayProdutItems(
        user.filters.productItem,
        productItems
      );
      // console.log("newDisplayText", newDisplayText);
      return newDisplayText;
    });
  }, [user.filters.productItem]);
  return (
    <>
      <Box
        sx={{
          boxShadow:
            user?.mode === "lite"
              ? "0px 0px 3px 1px #898b92"
              : "0px 0px 3px 1px black",
          color: foreColorCode(user?.mode ?? "dark"),
          height: "38px",
          width: "130px",
          borderRadius: "5px",
          backgroundColor: backGroundColorCode(user?.mode ?? "dark"),
          fontSize: "13px",
          display: "flex",
          alignItems: "center",
          flexWrap: "wrap",
          overflow: "hidden",
          // display: "-webkit-box",
          textOverflow: "ellipsis",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 2,
          cursor: "pointer",
          "&:hover": {
            color: foreColorCodeOnMouseOver(user?.mode ?? "lite"),
          },
        }}
        onClick={() => {
          setIsShowProductItemSelectModal(true);
        }}
      >
        {displayText.map((text) => (
          <div key={text.id}>{text.name}</div>
        ))}
      </Box>
      {isShowProductItemSelectModal && (
        <SelectProductItemsModal setIsShow={setIsShowProductItemSelectModal} />
      )}
    </>
  );
};

export default ProductItemsContainer;
